import { render, staticRenderFns } from "./ProsConsDialog.vue?vue&type=template&id=6bb977c0&"
import script from "./ProsConsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProsConsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports